import React from 'react';
import ReactDOM from 'react-dom';
import MapViewRide from './MapView.Ride.jsx';
import MapViewStart from './MapView.Start.jsx';
import MapViewBounds from './MapView.Bounds.jsx';
import * as L from "leaflet";

import ExtraMarkers from 'leaflet-extra-markers';
import { useRef } from 'react';
import { MapContainer, TileLayer, Circle, Marker, Popup, Polyline, FeatureGroup, useMap, Tooltip } from 'react-leaflet'

class MapView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedRide: null
    };
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.results != this.props.results) {
      this.setState({ selectedRide: null });
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (this.state.selectedRide != nextState.selectedRide) {
      return true;
    }
    if (this.props.resultsHash != nextProps.resultsHash) {
      return true;
    }
    if (this.props.hasUserStartPoint != nextProps.hasUserStartPoint) {
      return true;
    }
    if (nextProps.hasUserStartPoint) {
      if (this.props.locationLocalityLat != nextProps.locationLocalityLat) {

        return true;
      }
      if (this.props.locationLocalityLng != nextProps.locationLocalityLng) {

        return true;
      }
      if (this.props.locationDistance != nextProps.locationDistance) {
        return true;
      }
    }

    return false;
  }
  open(e, ride) {
    this.setState({ selectedRide: ride });
  }
  close(e) {
    this.setState({ selectedRide: null });
  }
  render() {
    console.log("Render Map View");
    var mapItems = [];
    var lowestLat = null;
    var highestLat = null;
    var lowestLng = null;
    var highestLng = null;
    var hasSelectedRide = this.state.selectedRide != null;
    for (let index = 0; index < this.props.results.length; index++) {
      const ride = this.props.results[index];
      if (!hasSelectedRide || this.state.selectedRide == ride.Id) {
        for (let i = 0; i < ride.Checkpoints.length; i++) {
          var checkPointData = ride.Checkpoints[i];
          if (lowestLat == null || lowestLat > checkPointData.Point.Latitude) {
            lowestLat = checkPointData.Point.Latitude;
          }
          if (highestLat == null || highestLat < checkPointData.Point.Latitude) {
            highestLat = checkPointData.Point.Latitude;
          }
          if (lowestLng == null || lowestLng > checkPointData.Point.Longitude) {
            lowestLng = checkPointData.Point.Longitude;
          }
          if (highestLng == null || highestLng < checkPointData.Point.Longitude) {
            highestLng = checkPointData.Point.Longitude;
          }
        }
        if(this.props.onlyShowPin){
           var rideView = <MapViewStart key={ride.Id} ride={ride} isSelected={hasSelectedRide} open={this.open} close={this.close} />
          mapItems.push(rideView);
        }else{
          var rideView = <MapViewRide key={ride.Id} ride={ride} isSelected={hasSelectedRide} open={this.open} close={this.close} />
          mapItems.push(rideView);
        }
        
      }
    }
    if (!hasSelectedRide) {
      //we dont want to show those enormous rides through europe
      if (lowestLat < 50) {
        lowestLat = 50;
      }
      if (highestLng > 2) {
        highestLng = 2;
      }
    }
    var locationCircle = null;
    if (this.props.hasUserStartPoint) {
      const fillBlueOptions = { fillColor: 'blue' }
      var homeIcon = L.ExtraMarkers.icon({
        icon: 'fa-home',
        markerColor: 'pink',
        shape: 'square',
        prefix: 'fa',
        extraClasses: "g-pl-5",
      });
      locationCircle = <Circle interactive={false} center={[this.props.locationLocalityLat, this.props.locationLocalityLng]} pathOptions={fillBlueOptions} radius={this.props.locationDistance * 1000} >
        <Marker icon={homeIcon} position={[this.props.locationLocalityLat, this.props.locationLocalityLng]}></Marker>
      </Circle>;
    }
   
    return (
    <MapContainer center={[51.509865, -0.118092]} zoom={12} scrollWheelZoom={true} className="event-finder-map border rounded shadow" >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {locationCircle}
      <MapViewBounds lowestLat={lowestLat} lowestLng={lowestLng} highestLat={highestLat} highestLng={highestLng} />
      {mapItems}
    </MapContainer>
    );
    
  }
}
export default MapView;

